import React from "react";
import PageHero from "../../COMPONENTS/PAGE_HERO";
import PageNav from "../../COMPONENTS/PAGE_NAV";
import ContactBlock from "../../COMPONENTS/CONTACT_BLOCK";
import PhysicianContactForm from "../../COMPONENTS/FORM/PHYSICIAN_CONTACT";
import Capabilities from "../HOME_PAGE/SECTIONS/CAPABILITIES";
import Benefits from "./SECTIONS/BENEFITS";
import PatientVoice from "./SECTIONS/PATIENT_VOICE";
import Journey from "./SECTIONS/JOURNEY";
import Managed from "./SECTIONS/MANAGED";
import { closing, lookingForward, physiciansHero } from "../../CONTENT/physicians";
import { Section, SectionIntro } from "../../COMPONENTS/UI";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

const links = [
  { id: "why", label: "Why research" },
  { id: "journey", label: "Assessment" },
  { id: "implementation", label: "Implementation" },
  { id: "management", label: "Management" },
  { id: "contact", label: "Contact" },
];

const PhysiciansPage = () => {
  useDocumentMeta({
    title: "For Physicians | Become a KUR Investigator",
    description:
      "Bring clinical research into your urgent care or private practice. KUR provides research infrastructure, staff, contracts and trial management at no cost.",
    path: "/physicians",
  });

  return (
    <>
      <PageHero
        id="physicians-hero-title"
        title={
          <>
            Become a clinical research <em>investigator.</em>
          </>
        }
        lead={physiciansHero.lead}
        actions={physiciansHero.actions}
        note={physiciansHero.note}
        image={physiciansHero.image}
        imageAlt={physiciansHero.imageAlt}
      />
      <PageNav links={links} cta={{ label: "Partner with KUR", href: "#contact" }} />
      <Benefits />
      <PatientVoice />
      <Journey />
      <Managed />
      <Capabilities />
      <Section tone="cloud" id="looking-forward" labelledBy="looking-forward-title">
        <SectionIntro id="looking-forward-title" eyebrow="Looking forward" title={lookingForward.title} />
        <div style={{ maxWidth: "46rem", display: "grid", gap: "var(--space-4)", lineHeight: "var(--leading-body)", color: "var(--color-text-muted)" }}>
          {lookingForward.paragraphs.map((p) => (
            <p key={p.slice(0, 20)} style={{ margin: 0 }}>
              {p}
            </p>
          ))}
        </div>
      </Section>
      <ContactBlock
        showMap
        eyebrow="Partner with KUR"
        title={closing.title}
        lead={closing.contact}
        points={[
          "Research infrastructure, staff and equipment funded by KUR",
          "Contracts, budgets and financials handled for you",
          "A steady pipeline of trials matched to your patients",
        ]}
        note={closing.text}
      >
        <PhysicianContactForm />
      </ContactBlock>
    </>
  );
};

export default PhysiciansPage;
